import { useEffect, useState } from 'react';
import { loadFromStorage, saveToStorage } from 'utils';

const STORAGE_KEY = 'partsListSortState';
const DEFAULT_SORT = Object.freeze({
  field: 'expiresAt',
  isDescending: true,
});

const loadSortFromStorage = () => loadFromStorage(STORAGE_KEY, DEFAULT_SORT);
const saveSortToStorage = (sortState) => {
  saveToStorage(STORAGE_KEY, sortState);
};

// Custom hook to manage sorting state, can be used by parent components for remote sorting
export default function useSortParts() {
  const [partsSort, setPartsSort] = useState(() => loadSortFromStorage());

  // Persist whenever sorting changes
  useEffect(() => {
    if (partsSort) {
      saveSortToStorage(partsSort);
    }
  }, [partsSort]);

  return {
    partsSort,
    setPartsSort,
  };
}
